

angular.module('forms')

.directive('serverValidation', function() {
	return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function(scope, element, attrs, ctrl) {
	    	/*ctrl.$validators.server = function(modelValue, viewValue) {
	    		console.log('Validity', attrs.serverError, scope.$eval(attrs.serverError));
		        return scope.$eval(attrs.serverError);
		    };*/
		    
		    scope.$watch(attrs.serverValidation, function(message) {
		    	var valid = !message;
		    	console.log('Validity', attrs.serverValidation, message);
		    	ctrl.$setValidity('server', valid);
		    });
		    
		    // TODO - instant server-side validation with $asyncValidators
		    // https://docs.angularjs.org/guide/forms
	    }
	}
});


